import React from "react";
import { ComponentExt } from "@src/utils/reactExt";
import * as styles from "./styles/index.scss"
import trafficActivitiesbg from "@assets/img/lifeTime/trafficActivitiesbg.png"
import monthTitle from "@assets/img/monthTitle.png"
import monthButton from "@assets/img/lifeTime/monthButton.png"
import bg0 from "@assets/img/lifeTime/bg0.png"
import bg1 from "@assets/img/lifeTime/bg1.png"
import bg2 from "@assets/img/lifeTime/bg2.png"
import bg3 from "@assets/img/lifeTime/bg3.png"
import norecord from "@assets/img/norecord.png"
import trafficActivitiesSuccess from "@assets/img/trafficActivitiesSuccess.png"
import { InputItem, Button } from 'antd-mobile'
import { createForm } from 'rc-form';
import { isValidPhone } from "@utils/index"
import SignInSuccessModal from './components/signInSuccessModal'
class LifetimeTrafficActivities extends ComponentExt<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            info: '',
            color: '',
            success: false,
            remainingCycle: '',
            resDetailRecord: [],
            getNum: '',
            showMoadl: false
        }
    }
    doSubmit = () => {
        this.props.form.validateFields(async (error, value) => {
            if (!error) {
                if (!isValidPhone(value.phone)) {
                    return this.setState({ info: '请输入正确的手机号', color: '' })
                }
                try {
                    this.setState({ info: '', color: '' })
                    this.$toast.loading('领取中，请稍后', 15)
                    const resDetailRecord = await this.api.actCustLogList({ phone: value.phone })
                    const { list = [] } = resDetailRecord;
                    this.setState({ resDetailRecord: list })
                    const res = await this.api.receiveActForPC({ phone: value.phone })
                    if (res && res != 'i0132') {
                        const resDetailRecord2 = await this.api.actCustLogList({ phone: value.phone })
                        const { list = [] } = resDetailRecord2;
                        this.setState({ resDetailRecord: list })
                        this.setState({ success: true })
                    } else if (res && res == 'i0132') {
                        this.setState({ showMoadl: true })
                    }
                    this.$toast.hide()
                } catch (error) {
                }
            }
        })
    };
    render(): React.ReactNode {
        const { getFieldProps } = this.props.form;
        return (
            <div className={styles.giftWrapper} style={{ backgroundImage: `url(${trafficActivitiesbg})` }}>
                <div className={styles.content} style={{ backgroundImage: `url(${bg0})` }}>
                    <div >
                        <div className={styles.title}
                        // style={{ backgroundImage: `url(${monthTitle})` }}
                        >
                            {/* <span> 活动赠礼</span> */}
                        </div>
                        {
                            !this.state.success &&
                            <>
                                <InputItem
                                    {...getFieldProps('phone',)}
                                    placeholder={'请输入手机号码'}
                                    className={styles.inputItem}
                                />
                                <p className={styles.giftInfo} style={{ color: this.state.color || 'red' }}>{this.state.info}</p>
                                <div className={styles.btn} style={{ backgroundImage: `url(${monthButton})` }} onClick={this.doSubmit}>立即领取</div>
                            </>
                        }
                        {
                            this.state.success && <>
                                <img src={trafficActivitiesSuccess} style={{ width: '1.7rem', marginBottom: '0.6rem' }} alt="" />
                                <div className={styles.successMsg}>
                                    <div>恭喜你成功领取</div>
                                </div>
                            </>
                        }
                    </div>
                </div>
                <div className={styles.bg1} style={{ backgroundImage: `url(${bg1})` }}></div>
                <div className={styles.bg2} style={{ backgroundImage: `url(${bg2})` }}>

                    {this.state.resDetailRecord.length == 0 && <>
                        <img src={norecord} style={{ width: '2.8rem' }} alt="" />
                        <div className={styles.bg2_text}>暂无领取记录</div>
                    </>}
                    {this.state.resDetailRecord.length != 0 && <>
                        {
                            this.state.resDetailRecord.map((item: any, index) => {
                                return <div className={styles.resDetailRecord} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #E8DFD7' }} key={index}>
                                    <div className={styles.resDetailRecord2}><div className={styles.resDetailRecord1}></div>{item.createTime}</div>
                                    <div className={styles.resDetailRecord3}>{item.getGoodsReleaseName}</div>
                                </div>
                            })
                        }
                    </>}
                </div>
                <div className={styles.bg3} style={{ backgroundImage: `url(${bg3})` }}>
                    {/* <div className={styles.title1}>活动规则</div>
                    <div className={styles.title2}>1、仅参与联想官方活动用户可在关注公众号后输入绑定的手机号参与活动；</div>
                    <div className={styles.title2}>2、每月仅可领取一次流量套餐，总领取次数以活动通知为准。</div>
                    <div className={styles.title1} style={{ marginTop: '0.2rem' }}>活动说明</div>
                    <div className={styles.title2}>1、套餐领取成功后将直接下发到账号绑定的设备并立即生效；</div>
                    <div className={styles.title2}>2、参与活动领取套餐前，请确认已实名激活设备，设备激活后方可正常下发。</div> */}
                </div>
                {this.state.showMoadl && <SignInSuccessModal
                    handleClose={() => {
                        this.setState({ showMoadl: false })
                    }}
                />}
            </div>
        )
    }
}
export default createForm()(LifetimeTrafficActivities)